// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__2PYZY","fund":"style_fund__2SbYe","refLink":"style_refLink__FCoGV","cards":"style_cards__3R1P4","balances":"style_balances__1v4ea"};